export default __webpack_public_path__ + "static/media/banner_4.79e5efc1.png";